import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";
import { toast } from "sonner";

const AdminLogin = () => {
  const { login, admin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin) navigate("/admin");
  }, [admin, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Échec de la connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center ivory-gold-bg px-4">
      <Seo title="Zone Administration" description="Accès réservé à l'administration du ministère." path="/admin/login" noindex />
      <div className="god-rays absolute inset-0" />
      <div className="relative w-full max-w-md bg-white rounded-2xl p-8 md:p-10 border border-gold/20 shadow-xl" data-testid="admin-login-card">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center w-16 h-16 mx-auto rounded-full bg-brown-dark text-gold-light mb-5">
            <Lock size={26} />
          </div>
          <h1 className="font-heading text-3xl font-medium text-brown-black">Zone Administration</h1>
          <p className="text-brown-black/55 text-sm mt-2">Prophète Steeve Orphôss — Ministère International</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-xs uppercase tracking-[0.15em] text-brown-dark/60 font-semibold mb-2">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email"
              className="w-full bg-transparent border-b border-gold/30 focus:border-gold focus:outline-none py-2.5 text-brown-black transition-colors" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.15em] text-brown-dark/60 font-semibold mb-2">Mot de passe</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password"
              className="w-full bg-transparent border-b border-gold/30 focus:border-gold focus:outline-none py-2.5 text-brown-black transition-colors" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-gold text-white font-semibold hover:bg-gold-light transition-all duration-300 disabled:opacity-60">
            <LogIn size={17} /> {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
